import React from "react";
import { TwoColumnsRowWrapper } from "./TwoColumnsRow.styles";
import { backgroundColourFormatter } from "../Global/utils/flexipageHelpers";
import SubTitle from "../Global/SubTitle/SubTitle";
import { StatamicHtml } from "../../../utils/statamicAssets";

const TwoColumnsRow = ({data}) => {

    const column1 = data.column_1_copy;
    const column2 = data.column_2_copy;
    const textAlignment = (data.text_alignment?.value || "").toLowerCase();
    const bgColor = backgroundColourFormatter(data.background_colour?.value) ? backgroundColourFormatter(data.background_colour?.value) : '';
    const subtitle = data.row_subtitle;
    const prevWidgetClass = data.addClassToPrevious ? data.addClassToPrevious : '';
    let columnWrapperClass = "columns-wrapper";

    if (textAlignment === 'center') {
        columnWrapperClass = "columns-wrapper align-center";
    }

    return(
        <TwoColumnsRowWrapper id={data.row_id} className={`flexipage-row ${bgColor}${prevWidgetClass}`} data-animation-trigger="true">
            <div className="flexipage-container" data-animation="animate__fadeIn" data-animation-duration="1s" data-animation-delay="0.1s">
                <SubTitle subtitle={subtitle} />
                <div className={columnWrapperClass}>
                    <div className="column">
                        {column1 && <StatamicHtml className="column-container" html={column1} />}
                    </div>
                    <div className="column">
                        {column2 && <StatamicHtml className="column-container" html={column2} />}
                    </div>
                </div>
            </div>
        </TwoColumnsRowWrapper>
    )
}

export default TwoColumnsRow;
